import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/header/header'
import Showcase from './components/showcase/showcase'
import Course from './components/course/course'
import Product from './components/product/product'
import Review from './components/review/review'
import Faq from './components/faq/faq'
import About from './components/about/about'
import Contact from './components/contact/contact'
import Footer from './components/footer/footer'
import Loading from './components/loading/loading'
import ScrollToTop from './components/scroll-to-top/scroll-to-top'
import FloatingWhatsApp from './components/floating-whatsapp/floating-whatsapp'
import FloatingFruits from './components/floating-fruits/floating-fruits'
import AnimatedBubbles from './components/animated-bubbles/animated-bubbles'
import ContactTrigger from './components/contact-trigger/contact-trigger'

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <AnimatePresence mode="wait">
        {isLoading && <Loading />}
      </AnimatePresence>
      
      <motion.div 
        className='App'
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoading ? 0 : 1 }}
        transition={{ duration: 0.5 }}
      >
        <AnimatedBubbles />
        <FloatingFruits />
        
        <Header />
        <Showcase />
        <Course />
        <Product />
        <Review />
        <Faq />
        <About />
        <Contact />
        <Footer />
        
        <ScrollToTop />
        <FloatingWhatsApp />
        <ContactTrigger />
      </motion.div>
    </>
  );
}

export default App;
